import React from 'react';
import {Typography} from '@mui/material';
import ImageFormatter from '@/ui/image-formatter/image-formatter';
import Box from "@mui/material/Box";
import {useRouter} from 'next/router';


import {SubCategory} from "@/types";

type ServiceTileProps = {
    service: SubCategory;
    height?: string;
    width?: string;
    fadeIn?: boolean;
    isBackground?: boolean;
};

const ServiceTile: React.FC<ServiceTileProps> = ({service, height, fadeIn, isBackground = true, width}: ServiceTileProps) => {
    const router = useRouter();
    return (
        <Box sx={{
            textAlign: 'center',
            width: width || '320px'
        }}
        >
            {/*todo swap this with a Hero*/}
            <ImageFormatter
                src={service?.images[0]?.original}
                alt={service?.images[0]?.originalAlt}
                title={service.title}
                width={width || '100%'}
                height={height || 'auto'}
                isBackground={isBackground}
                fadeIn={fadeIn}
            />
            <Typography component='h4' variant='h4'
                        sx={(theme) => ({
                            color: 'black',
                            fontSize: '16px',
                            padding: '5px',
                            margin: '2px',
                            [theme.breakpoints.down('md')]: {
                                fontSize: '16px !important',
                            }
                        })}
                        onClick={() => router.push(`/${service.headCategory.categoryType}/${service.headCategory.slug}/${service.slug}`)}
            >
                {service.title}
            </Typography>
        </Box>
    );
};

export default ServiceTile;
